<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
#app {
  height: 100vh;
  overflow: auto;
}
.van-tag--primary {
  background-color: #DA3738 !important;
}
</style>